export default __webpack_public_path__ + "static/media/Floorplan-Generator-Mix.7f196201.pdf";